<template>
  <div ref="dropdown" :class="buttonWarpperClass">
    <!-- Dropdown Toggle Button -->
    <button :class="buttonClass" @click="toggleDropdown">
      <span :class="buttonTextClass">{{ selectedLabel }}</span>

      <div :class="buttonIconClass">
        <img src="../../assets/images/create-quote-icon.png" />
      </div>

      <div :class="buttonDropdownIcon">
        <i class="fa fa-angle-down !text-[24px]"></i>
      </div>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isOpen" :class="dropdownListClass">
      <ul class="list-inline mb-0 p-2 max-h-60">
        <li v-for="(item, index) in items" :key="index" :class="dropdownListLIClass">
          <a :class="dropdownListAnchorClass" @click="selectItem(item)">
            {{ item[labelKey] }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue", "select"],
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    buttonWarpperClass: String,
    buttonClass: String,
    buttonIconClass: String,
    buttonDropdownIcon: String,
    buttonTextClass: String,
    buttonText: String,
    dropdownListClass: String,
    dropdownListLIClass: String,
    dropdownListAnchorClass: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.items.find(
        (item) => item[this.valueKey] === this.modelValue
      );
      return selected ? selected[this.labelKey] : this.buttonText;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectItem(item) {
      this.$emit("update:modelValue", item[this.valueKey]);
      this.$emit("select", item);
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>
